import { call, put, select, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import {
  UPDATE_PROFILE_PASSWORD,
  UPDATE_PROFILE_PASSWORD_FAIL,
  UPDATE_PROFILE_PASSWORD_SUCCESS,
  UpdatePasswordActionType,
  SET_LOADER
} from 'dealer-reducers'
import { authenticate } from './SignInSaga'
import { RootReducer } from 'src/redux/rootReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* UpdateProfilePasswordFlow(action: UpdatePasswordActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const userEmail = yield select((state: RootReducer) => state.userDataReducer.email)
    yield authenticate(userEmail, action.payload.currentPassword)
    const endpoint = '/api/v2/profiles/update_password'
    yield call(apiCall, {
      endpoint,
      method: PUT,
      params: {
        dealer: {
          current_password: action.payload.currentPassword,
          password: action.payload.newPassword,
          password_confirmation: action.payload.passwordConfirmation
        }
      }
    })
    yield put(UPDATE_PROFILE_PASSWORD_SUCCESS())
  } catch (error) {
    yield put(UPDATE_PROFILE_PASSWORD_FAIL())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* UpdateProfilePassword(): Generator<any, void, any> {
  yield takeLatest(UPDATE_PROFILE_PASSWORD, UpdateProfilePasswordFlow)
}
